/* ============ LEBAR SATU SLIDE ============

   Dipakai dua blok slider di bawah, sengaja ditulis sekali supaya keduanya
   tidak bisa lagi menyimpang sendiri sendiri.

   Yang diperbaiki: dulu keduanya memakai slides.clientWidth, yaitu lebar
   WADAH, sebagai kalau kalau itu lebar satu gambar.

   Di kartu koleksi anggapan itu kebetulan benar. Slide-nya flex 0 0 100%,
   jadi satu layar memang satu gambar dan kedua angka itu sama persis.
   Di halaman produk desktop satu layar memuat DUA gambar (flex-basis 50%),
   jadi clientWidth bernilai dua slide: satu tarikan melompat dua gambar,
   dan itu yang dikeluhkan klien.

   offsetWidth anak pertama dibaca tiap kali dipanggil, tidak disimpan.
   Nilainya berubah waktu jendela melewati 768. */
function kit247LebarSlide(s) {
  var anak = s.firstElementChild;
  return (anak && anak.offsetWidth) || s.clientWidth || 1;
}

/* KIT 247 collection.
   Dua hal saja: drawer Filter & Sort, dan toggle Read more pada deskripsi.
   Filter memakai filter native Shopify (sama seperti referensi), jadi cukup
   submit form ke URL collection. Tidak ada library. */
(function () {
  var root = document.querySelector('.kit-247');
  if (!root) return;

  /* ---------- deskripsi: read more ---------- */
  var desc = root.querySelector('[data-kit247-desc]');
  if (desc) {
    var body = desc.querySelector('.kit-247__desc__body');
    var btn = desc.querySelector('[data-kit247-desc-toggle]');
    // tombol hanya berguna kalau teksnya memang terpotong
    if (body.scrollHeight <= body.clientHeight + 4) {
      if (btn) btn.hidden = true;
    } else if (btn) {
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        desc.querySelector('[data-kit247-desc-more]').hidden = open;
        desc.querySelector('[data-kit247-desc-less]').hidden = !open;
      });
    }
  }

  /* ---------- drawer filter ---------- */
  var drawer = root.querySelector('[data-kit247-drawer]');
  var openBtn = root.querySelector('[data-kit247-filter-open]');
  if (!drawer || !openBtn) return;

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    // paksa reflow supaya transisi jalan
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('button, input, a');
    if (first) first.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 200);
    if (lastFocus) lastFocus.focus();
  }

  openBtn.addEventListener('click', open);
  root.querySelectorAll('[data-kit247-filter-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* ---------- terapkan filter ---------- */
  var form = drawer.querySelector('[data-kit247-filter-form]');
  if (!form) return;

  function apply() {
    var params = new URLSearchParams();
    form.querySelectorAll('input').forEach(function (input) {
      if (input.disabled || !input.name) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value !== '') {
        params.append(input.name, input.value);
      }
    });
    var base = window.location.pathname;
    window.location.href = params.toString() ? base + '?' + params.toString() : base;
  }

  // checkbox dan radio langsung menerapkan, sama seperti perilaku filter Shopify
  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"], input[type="radio"]')) apply();
  });
  // input harga tunggu Enter atau blur
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('input[type="number"]')) { e.preventDefault(); apply(); }
  });

  /* ---------- badge jumlah filter aktif ---------- */
  var badge = root.querySelector('[data-kit247-filter-count]');
  if (badge) {
    var active = 0;
    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function () { active++; });
    if (active > 0) { badge.textContent = String(active); badge.hidden = false; }
  }
})();

/* ============ TITIK PENANDA SLIDER GAMBAR KARTU ============

   Menyalakan titik yang sesuai waktu gambar di kartu digeser.

   Satu listener untuk SELURUH halaman, bukan satu per kartu. Di koleksi
   125 produk itu bedanya 1 listener lawan 125. Bisa begitu karena event
   scroll dipasang di fase capture: scroll memang tidak menggelembung ke
   atas, tapi tetap turun melewati document waktu fase capture.

   Efek sampingnya bagus: kartu yang baru masuk lewat filter AJAX pills
   langsung ikut terlayani tanpa perlu memasang ulang apa pun.

   Pembaruan dikumpulkan dulu lalu dikerjakan sekali per frame. Event
   scroll bisa menyala puluhan kali per detik dan pekerjaan aslinya cuma
   menukar kelas, jadi tidak perlu dijalankan setiap kali. */
(function () {
  'use strict';

  var menunggu = new Set();
  var terjadwal = false;

  function perbarui(slides) {
    var wadah = slides.parentElement && slides.parentElement.querySelector('[data-kit247-dots]');
    if (!wadah || !slides.clientWidth) return;

    var indeks = Math.round(slides.scrollLeft / kit247LebarSlide(slides));
    var titik = wadah.children;
    if (indeks < 0) indeks = 0;
    if (indeks > titik.length - 1) indeks = titik.length - 1;

    for (var i = 0; i < titik.length; i++) {
      titik[i].classList.toggle('is-on', i === indeks);
    }
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('kit-247__slides')) return;

    menunggu.add(t);
    if (terjadwal) return;
    terjadwal = true;

    requestAnimationFrame(function () {
      terjadwal = false;
      menunggu.forEach(perbarui);
      menunggu.clear();
    });
  }, true);
})();

/* ============ GESER GAMBAR KARTU PAKAI TARIKAN MOUSE ============

   Trackpad Mac punya geser horizontal bawaan, mouse Windows tidak.
   HANYA untuk mouse, sentuh dilewati karena geser bawaannya sudah baik.

   Riwayat dua kesalahan yang sudah diperbaiki di sini, supaya tidak terulang:

   1. dragstart menyala di elemen <a> pembungkus kartu, yang merupakan INDUK
      slider. Penjaga lama mencari closest('.kit-247__slides') dan tidak pernah
      cocok, jadi drag tautan bawaan browser membajak tarikan.

   2. Penentuan gambar tujuan memakai Math.round pada scrollLeft dibagi lebar.
      Itu menuntut tarikan lebih dari SEPARUH lebar slide sebelum berpindah.
      Tarikan pendek dibulatkan kembali ke gambar semula, jadi gambarnya
      bergerak lalu meloncat balik. Terasa patah patah sekaligus seperti tidak
      mau pindah. Sekarang dipakai ambang jarak plus ARAH tarikan.

   Penulisan scrollLeft sengaja LANGSUNG, tidak dikumpulkan ke rAF. Batching
   menambah satu frame jeda tanpa menghaluskan apa pun, dan kalau rAF
   dihambat browser, geserannya mati total. */
(function () {
  'use strict';

  var AMBANG_KLIK = 4;        // di bawah ini dianggap klik biasa, bukan tarikan
  var AMBANG_PINDAH = 40;     // piksel, cukup untuk berpindah satu gambar
  var seret = null, awalX = 0, awalScroll = 0, jauhnya = 0, arah = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;

    var s = e.target.closest && e.target.closest('.kit-247__slides');
    if (!s || s.scrollWidth <= s.clientWidth) return;

    seret = s;
    awalX = e.clientX;
    awalScroll = s.scrollLeft;
    jauhnya = 0;
    arah = 0;
    s.classList.add('is-dragging');
    s.style.scrollSnapType = 'none';
    /* paksa instan selama menarik. theme memasang scroll-behavior smooth di
       elemen html, dan kalau terwarisi ke sini tiap penulisan scrollLeft akan
       dianimasikan sehingga tarikan tertinggal dari kursor. */
    s.style.scrollBehavior = 'auto';

    /* tangkap penunjuk supaya event tetap datang walau kursor keluar dari
       slider, misalnya menarik melewati kartu sebelah. */
    if (s.setPointerCapture) {
      try { s.setPointerCapture(e.pointerId); } catch (err) {}
    }
  });

  document.addEventListener('pointermove', function (e) {
    if (!seret) return;
    var d = e.clientX - awalX;
    if (Math.abs(d) > jauhnya) jauhnya = Math.abs(d);
    if (Math.abs(d) > AMBANG_KLIK) arah = d < 0 ? 1 : -1;   // 1 maju, -1 mundur

    seret.scrollLeft = awalScroll - d;
    e.preventDefault();
  });

  function lepas() {
    if (!seret) return;
    var s = seret;
    seret = null;
    s.classList.remove('is-dragging');

    var lebar = kit247LebarSlide(s);
    var indeksAwal = Math.round(awalScroll / lebar);
    var tujuanIndeks;

    if (jauhnya >= AMBANG_PINDAH && arah !== 0) {
      tujuanIndeks = indeksAwal + arah;                 // cukup jauh, pindah satu
    } else {
      tujuanIndeks = Math.round(s.scrollLeft / lebar);  // terlalu pendek, kembali
    }

    /* Indeks slide terjauh yang masih bisa duduk di TEPI KIRI, jadi
       pembaginya lebar satu slide sementara yang dikurangi lebar wadah.
       Dulu keduanya clientWidth. Di koleksi hasilnya sama persis karena
       satu slide memang selebar wadah; di halaman produk yang memuat dua
       gambar, rumus lama memberi indeks satu slide terlalu jauh dan
       guliran mentok di posisi yang tidak sejajar snap. */
    var maksIndeks = Math.round((s.scrollWidth - s.clientWidth) / lebar);
    if (tujuanIndeks < 0) tujuanIndeks = 0;
    if (tujuanIndeks > maksIndeks) tujuanIndeks = maksIndeks;

    /* Snap dibiarkan mati dulu, luncurkan sendiri dengan behavior smooth, baru
       snap dikembalikan sesudah berhenti. Kalau snap langsung dinyalakan lagi,
       browser meloncat seketika ke titik snap dan itu terasa patah. */
    s.style.scrollBehavior = '';
    try {
      s.scrollTo({ left: tujuanIndeks * lebar, behavior: 'smooth' });
    } catch (err) {
      s.scrollLeft = tujuanIndeks * lebar;
    }

    var pulihkan = function () {
      s.style.scrollSnapType = '';
      s.removeEventListener('scrollend', pulihkan);
    };
    if ('onscrollend' in s) {
      s.addEventListener('scrollend', pulihkan);
      setTimeout(pulihkan, 700);
    } else {
      setTimeout(pulihkan, 400);
    }

    if (jauhnya <= AMBANG_KLIK) return;   // cuma klik, biarkan kartu terbuka

    var telan = function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      document.removeEventListener('click', telan, true);
    };
    document.addEventListener('click', telan, true);
    setTimeout(function () { document.removeEventListener('click', telan, true); }, 300);
  }

  document.addEventListener('pointerup', lepas);
  document.addEventListener('pointercancel', lepas);

  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('.kit-247__card')) e.preventDefault();
  });
})();
